<div class="doc-viewer-container">
  <!-- Header with title and close button -->
  <div class="doc-viewer-header">
    <h2 class="doc-title">{{ dialogData.title || 'Document Viewer' }}</h2>
    <div class="actions">
      <button mat-icon-button (click)="close()" class="close-button" aria-label="Close document viewer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Document content area -->
  <div class="doc-viewer-content" mat-dialog-content>
    <div class="document-container">
      <!-- PDF Document -->
      @if (isPdf) {
        <iframe 
          [src]="safeUrl" 
          class="document-frame"
          frameborder="0">
        </iframe>
      }
      
      <!-- Image Document -->
      @if (isImage) {
        <img 
          [src]="dialogData.documentUrl" 
          class="document-image"
          [alt]="dialogData.title || 'Document'"
        />
      }
      
      <!-- Other document types -->
      @if (!isPdf && !isImage) {
        <iframe 
          [src]="safeUrl" 
          class="document-frame"
          frameborder="0">
        </iframe>
      }
    </div>
  </div>
</div>
